export const TEST_ID_ORDER_LINE_METADATA = "order-line-metadata";
export const TEST_ID_PRODUCT_VARIANT_METADATA = "product-variant-metadata";
